import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
/** yup **/
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
/**fields */
import CustomTextField from "../CustomTextField";
import { limpiarEstadoCursos } from '../../Redux/ghResponde';
import { useDispatch } from 'react-redux';

const ModalGestionResuelta = ({ open, handleClose, data }) => {
    const dispatch = useDispatch()
    const validacionSchema = yup.object().shape({
    });

    const { handleSubmit, setValue, ...methods } = useForm({
        shouldUnregister: false,
        mode: "onChange",
        defaultValues: {
            new_fecharesolucion: "",
            new_name: "",
            new_tema: "",
            new_tipodeincidencia: "",
            new_resolucion: "",
        },
        resolver: yupResolver(validacionSchema),
    });

    // Forma más resumida utilizando el operador spread
    React.useEffect(() => {
        if (data) {
            Object.keys(data).forEach((key) => {
                setValue(key, data[key]);
            });
        }
    }, [data, setValue]);

    const cerrarYlimpiar = () => {
        handleClose(false)
        dispatch(limpiarEstadoCursos())
    }

    return (
        <Dialog
            open={open}
            onClose={() => cerrarYlimpiar()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={'xl'}
        >
            <DialogTitle>Mi gestión resuelta</DialogTitle>
            <DialogContent>
                <FormProvider {...methods}>
                    <form>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <CustomTextField
                                    Component={TextField}
                                    type="text"
                                    label="Título"
                                    name="new_name"
                                    readOnly={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomTextField
                                    Component={TextField}
                                    type="text"
                                    label="Tipo de incidencia"
                                    name="new_tipodeincidencia"
                                    readOnly={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomTextField
                                    Component={TextField}
                                    type="text"
                                    label="Tema"
                                    name="new_tema"
                                    readOnly={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomTextField
                                    Component={TextField}
                                    type="text"
                                    label="Fecha de resolución"
                                    name="new_fecharesolucion"
                                    readOnly={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <CustomTextField
                                    Component={TextField}
                                    type="text"
                                    label="Resolución"
                                    name="new_resolucion"
                                    readOnly={true}
                                    multiline={true}
                                    rows={8}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </FormProvider>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => cerrarYlimpiar()} color="secondary" variant="contained">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalGestionResuelta